import { IFormattedOtherProject } from '../../types/project';
import { IApplicationState } from '../../types/redux';
import { formatPrice } from '../../utils/formatters/price';
import { stringifyFeatures } from '../../utils/projectFeatures';

export const selectOtherProjects = (state: IApplicationState): IFormattedOtherProject[] => {
  return state.projectData.otherProjects.map(project => ({
    ...project,
    features: stringifyFeatures({ area: project.area, floors: project.floorCount }),
    startPrice: project.startPrice ? `от ${formatPrice(project.startPrice)}` : /* istanbul ignore next */ '',
  }));
};
